import { CDBSidebar, CDBSidebarContent, CDBSidebarHeader, CDBSidebarMenu, CDBSidebarMenuItem } from 'cdbreact';
import './sidebar.scss';
import img from "../../../assets/ttec-logo-white.svg";
import fullimg from "../../../assets/ttec-logo-white_Full.png";
import HeaderSection from '../header/headerSection.jsx';
import { useNavigate } from "react-router-dom";
import { CPPCODELIST, GETUSERDETAILS_URL, NOACCESS, ADMINBLADE, NEWCLIENTREQUEST, NOTFOUND, NEWCPPREQUEST, NEWPROGRAMREQUEST, NEWPROJECTREQUEST, NEWPROGRAMPROJECTREQUEST, LOGIN, SUPERADMIN } from "../../../constants";
import { useEffect, useState } from "react";
import axios from 'axios';
import { Route, Routes } from "react-router-dom";
import { NewClientRequestForm } from '../../../pages/newClientRequest/newClientRequestForm';
import { CppoCodeList } from '../../../pages/cppoCodeSearch/CppoCodeList';
import { DropDownBlade } from '../../../pages/adminBlade/DropDownBlade';
import NoAccess from '../../shared/NoAccess.jsx';
import NotFound from '../../shared/NotFound.jsx';
import Spinner from "../../shared/spinner.jsx";
import { NewCPPRequest } from '../../../pages/newCPPRequest/newCPPRequest';
import { NewProgramProjectRequestForm } from '../../../pages/newProgramProjectRequest/newProgramProjectRequest';
import { NewProjectRequestForm } from '../../../pages/newProjectRequest/newProjectRequest';
import { ProgramProjectList } from '../../../pages/cppoCodeSearch/ProgramProjectList';
import { Tooltip } from 'primereact/tooltip';
import ProtectedRoute from  '../../../routes/protectedRoutes';
import PublicRoute from '../../../routes/publicRoutes';
import Login from '../../auth/login/login';
import SessionExpiredAlert from "./sessionexpiredalert.jsx";
import RouteMasker from './routeMasker.jsx';
import SuperAdminRoleAssignment  from '../../../pages/superadmin/superAdmin';

const Sidebar = () => {
  const navigate = useNavigate();
  const [username, setuserName] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  const [isGNA, setIsGNA] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false); 
  const [isTab1Selected, setIsTab1Selected] = useState(true); 
  const [isTab2Selected, setIsTab2Selected] = useState(false); 
  const [isTab3Selected, setIsTab3Selected] = useState(false); 
  const [isTab4Selected, setIsTab4Selected] = useState(false); 
  const [isTab5Selected, setIsTab5Selected] = useState(false); 
  const [isAuthenticated, setisAuthenticated] = useState(false); 
  const [sessionExpired, setSessionExpired] = useState(false);
  const [hassecgroup, sethassecgroup] = useState(false);
  const [isAdminCodeApprover, setIsAdminCodeApprover] = useState(false);
  const [isAdminCodeCreation, setIsAdminCodeCreation] = useState(false);
  const [showLP, setShowLP] = useState(false);
  const [accesspath, setAccessPath] = useState("");
  const [isSuperAdmin, setisSuperAdmin] = useState(false);
  const [errorStatus, setErrorStatus] = useState(false);

  const toggleSidebar = () => {
    setIsExpanded(!isExpanded); 
  };

  useEffect(() => {
    if (username === "") {
      getDetails();
    }
  }, []);

  useEffect(() => {
    if(accesspath === "/" || accesspath === "" || accesspath === NEWCPPREQUEST)
      {
        handleClick(1);
      }
      else if(accesspath === NEWCLIENTREQUEST || accesspath === NEWPROGRAMREQUEST ||accesspath === NEWPROJECTREQUEST)
      {
        handleClick(1);
      }
      else if(accesspath === CPPCODELIST){
        handleClick(2);
      }
      else if(accesspath === NEWPROGRAMPROJECTREQUEST){
        handleClick(3);
      }
      else if(accesspath === ADMINBLADE){
        handleClick(4);
      }
      else if(accesspath === SUPERADMIN){
        handleClick(5);
      }
      else if(accesspath !== CPPCODELIST && accesspath !== CPPCODELIST && accesspath !== NEWPROGRAMPROJECTREQUEST && accesspath !== ADMINBLADE && accesspath !== "/" && accesspath !== "" && accesspath !== NEWCLIENTREQUEST && accesspath !== NEWPROGRAMREQUEST && accesspath !== NEWPROJECTREQUEST && accesspath !== SUPERADMIN)
      {
        handleClick(6);
      }
  },[accesspath]);

  const getDetails = async () => {
    const path = window.location.pathname;
    let url =  process.env.REACT_APP_BASE_URI + GETUSERDETAILS_URL;

    const headers = {
      "Content-Type": 'application/json',
    }
    const res = await new Promise((resolve, reject) => {
      try {
        setShowLoader(true);
        axios.get(url, { headers: headers, withCredentials: true })
          .then((res) => {
            setShowLoader(false);
            resolve(res);
          })
          .catch((err) => {
            setShowLoader(false);
            resolve(err);
          });
      } catch (error) {
        setShowLoader(false);
        reject(error);
      }
    });

    if (res?.data?.httpStatus === 200) {
      if (res?.data?.data?.secGrp) {
        setuserName(res?.data?.data?.user);
        if (res?.data?.data?.secGrp) {
          sethassecgroup(true);
          setIsAdminCodeApprover(res?.data?.data?.isAdminApprover);
          setIsAdminCodeCreation(res?.data?.data?.isAdminCreator);
          setShowLP(res?.data?.data?.showLP);
          setIsGNA(res?.data?.data?.isGA);
          setisSuperAdmin(res?.data?.data?.isSuperAdmin);
          setisAuthenticated(res?.data?.data?.active);
          setSessionExpired(!res?.data?.data?.active);
          if (res?.data?.data?.secGrp) {
            if(res?.data?.data?.isAdminCreator) {
              (path === "/" || path === "") ? navigate(NEWCPPREQUEST) : navigate(path);
              (path === "/" || path === "") ? setAccessPath(NEWCPPREQUEST) : setAccessPath(path);            
            }
            else if (res?.data?.data?.isAdminApprover)
              {
                (path === "/" || path === "") ? navigate(CPPCODELIST) : navigate(path);
                (path === "/" || path === "") ? setAccessPath(CPPCODELIST) : setAccessPath(path);
              }
              else if(!res?.data?.data?.isAdminApprover && !res?.data?.data?.isAdminCreator && !res?.data?.data?.isGA && res?.data?.data?.isSuperAdmin)
              {
                (path === "/" || path === "") ? navigate(SUPERADMIN) : navigate(path);
                (path === "/" || path === "") ? setAccessPath(SUPERADMIN) : setAccessPath(path);
              }
            else {
              (path === "/" || path === "") ? navigate(NEWCPPREQUEST) : navigate(path);
              (path === "/" || path === "") ? setAccessPath(NEWCPPREQUEST) : setAccessPath(path);
            }
          }
        }
        else {
          sethassecgroup(false);
          navigate(NOACCESS);
        }
      }
      else {
        sethassecgroup(false);
        navigate(NOACCESS);
      }
    } else {
      if(res?.response?.status === 401){
      setErrorStatus(res?.response?.data?.message?.message);
      }
       setisAuthenticated(false);
       navigate(LOGIN);
      }
  }


  const handleClick = (index) => {
    if (index === 1) {
      navigate(NEWCPPREQUEST);
      setIsTab1Selected(true);
      setIsTab2Selected(false);
      setIsTab3Selected(false);
      setIsTab4Selected(false);
      setIsTab5Selected(false);
    }
    else if (index === 2) {
      navigate(CPPCODELIST);
      setIsTab1Selected(false);
      setIsTab2Selected(true);
      setIsTab3Selected(false);
      setIsTab4Selected(false);
      setIsTab5Selected(false);
    }
    else if (index === 3) {
      navigate(NEWPROGRAMPROJECTREQUEST);
      setIsTab1Selected(false);
      setIsTab2Selected(false);
      setIsTab3Selected(true);
      setIsTab4Selected(false);
      setIsTab5Selected(false);
    }
    else if (index === 4) {
      navigate(ADMINBLADE);
      setIsTab1Selected(false);
      setIsTab2Selected(false);
      setIsTab3Selected(false);
      setIsTab4Selected(true);
      setIsTab5Selected(false);
    }    
    else if(index === 5){
      navigate(SUPERADMIN);
      setIsTab1Selected(false);
      setIsTab2Selected(false);
      setIsTab3Selected(false);
      setIsTab4Selected(false);
      setIsTab5Selected(true);
    } 
    else{
      setIsTab1Selected(false);
      setIsTab2Selected(false);
      setIsTab3Selected(false);
      setIsTab4Selected(false);
      setIsTab5Selected(false);
    }  
  };


  return (
    <>
    {username !== "" &&
      <div>
         {sessionExpired && (
        <SessionExpiredAlert onRelogin={() => window.location.href = {LOGIN}} />
      )}
        <CDBSidebar toggled={!isExpanded} textColor="white" backgroundColor="#3299FF" id="side-bar">
          <img
            src={!isExpanded ? img : fullimg}
            alt=""
            style={{ width: !isExpanded ? '25px' : '80px', paddingLeft: '2px', paddingTop: '20px', alignSelf: 'center' }}
          />
          <CDBSidebarHeader prefix={<i className="fa fa-bars fa-large"></i>} onClick={toggleSidebar}>
          </CDBSidebarHeader>
          <CDBSidebarContent>
            <CDBSidebarMenu>
              <>
                {(isAdminCodeCreation || isGNA) &&
                  <div className={!isExpanded ? 'clsIcon' : 'clsIcon-1'}>
                    <Tooltip target=".custom-target-icon" />
                    <i className="custom-target-icon"
                      data-pr-tooltip="New CPP Requests"
                      data-pr-position="right"
                      data-pr-at="right-5 top"
                      data-pr-my="left center-2"
                      style={{  fontSize: !isExpanded ? '1.2rem' : '1rem',
                      cursor: 'pointer',
                      height: '3rem'   }}
                      onClick={() => handleClick(1)}>
                        <CDBSidebarMenuItem icon='th-large' active={isTab1Selected}>New CPP Requests</CDBSidebarMenuItem>
                    </i>
                  </div>
                }
                {(isAdminCodeApprover || isAdminCodeCreation) &&
                  <div className={!isExpanded ? 'clsIcon' : 'clsIcon-1'}>
                    <Tooltip target=".custom-target-icon-1" />
                    <i className="custom-target-icon-1"
                       data-pr-position="right"
                       data-pr-at="right+5 top"
                       data-pr-my="left center-2"
                      data-pr-tooltip="CPP Requests List"
                      style={{ fontSize: !isExpanded ? '1.2rem' : '1rem',
                      cursor: 'pointer',
                      height: '3rem'       
                     }}
                      onClick={() => handleClick(2)}>
                      <CDBSidebarMenuItem icon='list-ol' active={isTab2Selected}>CPP Requests List</CDBSidebarMenuItem>
                    </i>
                  </div>
                }
                {isGNA &&
                   <div className={!isExpanded ? 'clsIcon' : 'clsIcon-1'}>
                   <Tooltip target=".custom-target-icon-2" />
                   <i className="custom-target-icon-2"
                      data-pr-position="right"
                      data-pr-at="right+5 top"
                      data-pr-my="left center-2"
                     data-pr-tooltip="Program/Project Requests List"
                     style={{ fontSize: !isExpanded ? '1.2rem' : '1rem',
                     cursor: 'pointer',
                     height: '3rem'      
                    }}
                     onClick={() => handleClick(3)}>
                      <CDBSidebarMenuItem icon='list-ul' active={isTab3Selected}>Program/Project Requests List</CDBSidebarMenuItem>
                      </i>
                      </div>
                }
                {(isAdminCodeApprover) &&
                   <div className={!isExpanded ? 'clsIcon' : 'clsIcon-1'}>
                   <Tooltip target=".custom-target-icon-3" />
                   <i className="custom-target-icon-3"
                      data-pr-position="right"
                      data-pr-at="right+5 top"
                      data-pr-my="left center-2"
                     data-pr-tooltip="Dropdown Management"
                     style={{ fontSize: !isExpanded ? '1.2rem' : '1rem',
                     cursor: 'pointer',
                     height: '3rem'       
                    }}
                     onClick={() => handleClick(4)}>
                      <CDBSidebarMenuItem icon='plus-square' active={isTab4Selected}>Dropdown Management</CDBSidebarMenuItem>
                      </i>
                      </div>
                }
                {isSuperAdmin &&
                <div className={!isExpanded ? 'clsIcon' : 'clsIcon-1'}>
                    <Tooltip target=".custom-target-icon-1" />
                    <i className="custom-target-icon-1"
                       data-pr-position="right"
                       data-pr-at="right+5 top"
                       data-pr-my="left center-2"
                      data-pr-tooltip="Role Management"
                      style={{ fontSize: !isExpanded ? '1.2rem' : '1rem',
                      cursor: 'pointer',
                      height: '3rem'       
                     }}
                      onClick={() => handleClick(5)}>
                      <CDBSidebarMenuItem icon='user-circle' active={isTab5Selected}>Role Management</CDBSidebarMenuItem>
                    </i>
                  </div>
               }
              </>
            </CDBSidebarMenu>
          </CDBSidebarContent>
        </CDBSidebar>
      </div>}
      <div style={{  width: username === "" ? '100%' : '93%'}}>
        {username !== "" &&
        <HeaderSection details={{ username: username, showLoader: showLoader }} />}
        {showLoader && (
          <div className="divSpinner">
            <Spinner />
          </div>
        )}
       <RouteMasker/>
       <Routes>
        <Route element={<PublicRoute isAuthenticated={isAuthenticated} isCPPCodeApprover={!showLP} hassecgroup={hassecgroup} />}>
            <Route exact path={LOGIN} element={<Login status={errorStatus}/>} />
        </Route>
        <Route element={<ProtectedRoute isAuthenticated={isAuthenticated}/> }>
            <Route exact path={CPPCODELIST} element={<CppoCodeList showbutton={isAdminCodeApprover} />} />
            <Route exact path={NEWCLIENTREQUEST} element={<NewClientRequestForm showHeader={true} mode="Add" />} />
            <Route exact path={NEWCPPREQUEST} element={<NewCPPRequest showHeader={true} isGAGroup={isGNA} isCodeCreation={isAdminCodeCreation} />} />
            <Route exact path={NEWPROJECTREQUEST} element={<NewProjectRequestForm />} />
            <Route exact path={NEWPROGRAMREQUEST} element={<NewProgramProjectRequestForm />} />
            <Route exact path={NEWPROGRAMPROJECTREQUEST} element={<ProgramProjectList showHeader={true} />} />
            <Route exact path={ADMINBLADE} element={<DropDownBlade showHeader={true}  />} />
            <Route exact path={SUPERADMIN} element={<SuperAdminRoleAssignment username={username}  />} />
            <Route exact path={NOTFOUND} element={<NotFound />} />
            <Route exact path={NOACCESS} element={<NoAccess />} />
          </Route>
        </Routes>
      </div>
    </>
  );
};

export default Sidebar;
